module.exports = __webpack_public_path__ + "img/winDefalut.a54be3df.png";